import React from 'react';
import { Box } from '@mui/material';
import Header from '../../components/LandingPage/Header';
import Hero from './Hero';
import Chat from './Chat';
import Footer from '../../components/LandingPage/Footer';
import Vantages from './Vantages';

const LandingPageCampaign: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column">
      <Header />
      <Hero />
      <Chat />
      <Vantages />
      <Footer />
    </Box>
  );
};

export default LandingPageCampaign;
